import { EditCustomerResponsiblesOutDto, EditCustomerResponsiblesInDto } from '../../../types/customer-responsible.dto'

export const EDIT_CUSTOMER_RESPONSIBLES = 'EDIT_CUSTOMER_RESPONSIBLES'
export const EDIT_CUSTOMER_RESPONSIBLES_SUCCESS = 'EDIT_CUSTOMER_RESPONSIBLES_SUCCESS'
export const EDIT_CUSTOMER_RESPONSIBLES_ERROR = 'EDIT_CUSTOMER_RESPONSIBLES_ERROR'
export const RESET_EDIT_CUSTOMER_RESPONSIBLES = 'RESET_EDIT_CUSTOMER_RESPONSIBLES'

export interface EditCustomerResponsibles {
  type: typeof EDIT_CUSTOMER_RESPONSIBLES
  payload: EditCustomerResponsiblesOutDto
}

export interface EditCustomerResponsiblesSuccess {
  type: typeof EDIT_CUSTOMER_RESPONSIBLES_SUCCESS
  payload: EditCustomerResponsiblesInDto
}

export interface EditCustomerResponsiblesError {
  type: typeof EDIT_CUSTOMER_RESPONSIBLES_ERROR
  payload: string | boolean
}

export interface ResetEditCustomerResponsibles {
  type: typeof RESET_EDIT_CUSTOMER_RESPONSIBLES
  payload: null
}
export interface State {
  data: EditCustomerResponsiblesInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditCustomerResponsibles | EditCustomerResponsiblesSuccess | EditCustomerResponsiblesError | ResetEditCustomerResponsibles
